import type { CountryEnum } from "src/types/country";
import type { Id } from "src/types/id";
import type { PosCashierInfo } from "src/types/posCashierInfo";
import type { Address, BillingAddress } from "./address";
import type { OrganizationDetails } from "./organization";
import type { PosChannel } from "./posChannel";
import type { SFBillingTypeEnum, SFPaymentTypeEnum, SFPosTypeEnum, SFUser } from "./sales-force";
import type { User } from "./user";

export enum PosStatus {
    creating = "creating",
    activated = "activated",
    suspended = "suspended",
}

export enum PosKeys {
    uuid = "uuid",
    id = "id",
    name = "name",
    legalName = "legalName",
    siret = "siret",
    vatNumber = "vatNumber",
    companyId = "companyId",
    isVerified = "isVerified",
    organization = "organization",
    user = "user",
    status = "status",
    posType = "posType",
    billingEmail = "billingEmail",
    orgaId = "orgaId",
    timezone = "timezone",
}

export interface Pos {
    uuid?: string;
    id: number;
    name: string;
    isVerified?: boolean;
    organization?: OrganizationDetails;
    organizationId?: number;
    users?: User[];
    posCashierInfoList?: PosCashierInfo[];
    posChannels?: PosChannel[];
    status: PosStatus;
    createdDateUTC: Date;
    timezone: string;
    validSetup?: boolean;
    countryCode?: CountryEnum;
    currentGroupId?: Id;
}

export interface PosDetails extends Pos, Address, BillingAddress {
    legalName?: string;
    siret?: string;
    vatNumber?: string;
    companyId?: string;
    billingEmail?: string;
    posType?: SFPosTypeEnum;
    billingType?: SFBillingTypeEnum;
    paymentType?: SFPaymentTypeEnum;
    stripeId?: string;
    orgaId?: number;
    parentId?: string;
    ownerId?: string;
    owner?: SFUser;
    countryCode?: CountryEnum;
    latitude?: number | null;
    longitude?: number | null;
}
